import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class ActivateService {
  constructor(private http: HttpClient) {}

  get(key: string): Observable<any> {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/activate`, {
      params: new HttpParams().set('key', key)
    });
  }
}
